import api from '@/api'
export default {
    namespaced: true,
    state: {
        total:0,
        appaccountarr:[],
        editdata:{},
        title:''
    },
    getters: {
    },
    mutations: {
        //存储用户信息
        SET_APPACCOUNTLIST: (state, obj) => {

            state.total = obj.total
            state.appaccountarr=[...obj.data]
        },
        SET_EDITDATA: (state, obj) => {

            state.editdata={...obj}
        },
        SET_TITLE: (state, title) => {

            state.title=title
        },
        DEL_DATA: (state, index) => {
            state.appaccountarr.splice(index,1)
        },
        CLEAR_APPACCOUNTLIST: (state) => {

            state.total = 0
            state.appaccountarr=[]

        },


    },
    actions: {
        async getAppaccountlist({ commit },params={page:1}) {
            
            let {code,message,data}=await api.getappaccountlist(params)
            if (code == 200) {
                commit('SET_APPACCOUNTLIST', data);
           
                return data;
            } else {
                return Promise.reject(new Error(message));
            }
        },
    },
}